import type { IconType } from "react-icons";
import { createElement } from "react";
import { cx } from "@/utils/ui/uiHelpers";

const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
  showIcon = false,
  text = "",
  buttonType = "button",
  status = "",
  colorCSSClassnames = "bg-brandGreen hover:bg-brandYellow hover:text-black hover:animate-pulse mt-4",
  fullWidth = false,
  disabled = false,
  icon,
}) => {
  return (
    <>
      <button
        type={buttonType}
        className={cx(
          "poppins items-center px-3 py-3 border border-transparent shadow-md text-sm leading-4 rounded-lg text-white",
          `${colorCSSClassnames}`,
          status === "pending" ? "animate-pulse" : "",
          fullWidth ? "w-full text-center" : "inline-flex",
          "disabled:cursor-not-allowed disabled:opacity-50",
        )}
        disabled={disabled}
      >
        {text}
        {showIcon && icon ? createElement(icon) : ""}
      </button>
    </>
  );
};

type ButtonWithIconProps = {
  showIcon?: boolean;
  icon?: IconType;
  text?: string;
  buttonType: "button" | "submit" | "reset" | undefined;
  status?: string;
  colorCSSClassnames?: string;
  group?: boolean;
  groupAlign?: string;
  fullWidth?: boolean;
  disabled?: boolean;
};

export default ButtonWithIcon;
